// extracted by mini-css-extract-plugin
module.exports = {"content":"register_content__39JcU","form":"register_form__gC8qZ","textInput":"register_textInput__4UI35","media":"register_media__6cGWS","picture":"register_picture__vS6y9"};